// src/packages/chubb/pa/chubb_pa_series_d_2025/index.js
import ChubbPASeriesDCard from "./ChubbPASeriesDCard";
import ChubbPASeriesDDetails from "./ChubbPASeriesDDetails";
import "./chubb_pa_series_d.css";

/** Chubb — PA Series D (Plans 1–8 + Kid), Effective 2025 */
export default {
  id: "chubb_pa_series_d_2025",
  company: "ชับบ์ (Chubb)",        // ให้ตรงกับ COMPANY_INFO
  productLine: "non-motor",
  categories: ["personal accident", "PA", "health"],
  nameTH: "Chubb PA Series D — แผน 1–8 + Kid",
  description: "PA แบบ Series D: คุ้มครองชีวิต/ทุพพลภาพ/ค่ารักษา + แพ็กครอบครัว",
  accent: "#f59e0b",               // โทนส้มตามดีไซน์ใบปลิว
  expiresAt: "9999-12-31",
  card: ChubbPASeriesDCard,
  detail: ChubbPASeriesDDetails,
  active: true,
};
